import Export from '@/services/export'
import Import from '@/services/import'
import Mailer from '@/services/mailer'
import Assignor from '@/services/assignor'
import Document from '@/services/documents'
import Invoice from '@/services/invoice'
import Serasa from '@/services/serasa'
import { formatErrors } from '@utils/errors-alert'
import { bus } from '@/plugins/event-bus'

const fetch = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Assignor.all().then((response) => {
      commit('SET_LIST', response.data.data)
      resolve(response.data)
    })
    .catch((error) => {
      reject(error)
    })
  })
}

const fetchTemplateContractOptions = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Assignor.templateContractOptions().then((response) => {
      commit('SET_TEMPLATE_CONTRACT_OPTIONS', response.data)
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    })
  })
}

const sendDocumentations = async ({ commit }, { id, obj }) => {
  return new Promise((resolve, reject) => {
    Assignor.sendDocumentations(id, obj)
      .then((response) => {
        commit('SET_ASSIGNOR', response.data)
        resolve(response)
      })
      .catch((error) => {
        commit('SET_ERRORS', error.response.data)
        reject(error)
      })
  })
}

const fetchEligible = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Assignor.allElegible().then((response) => {
      commit('SET_LIST', response.data.data)
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    })
  })
}

const fetchCurrentAssignor = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Assignor.current().then((response) => {
      commit('SET_CURRENT_ASSIGNOR', response.data)
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    })
  })
}

const fetchAssignorsWithInvoiceImported = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Assignor.withInvoices().then((response) => {
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    })
  })
}

const findInvoiceByAssignor = async (context, id) => {
  return new Promise((resolve, reject) => {
    Invoice.byAssignor().then((response) => {
      resolve(response.data)
    })
    .catch((error) => {
      reject(error)
    })
  })
}

const findByToken = async (context, token) => {
  return new Promise((resolve, reject) => {
    Assignor.byToken(token).then((response) => {
      resolve(response.data)
    })
    .catch((error) => {
      reject(error)
    })
  })
}

const findSerasa = async (context, id) => {
  return new Promise((resolve, reject) => {
    Assignor.checkSerasa(id)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const findAssignorsWithProtestos = async (context, id) => {
  return new Promise((resolve, reject) => {
    Assignor.withProtesto(id)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const save = (context, payload) => {
  return new Promise((resolve, reject) => {
    const { verb, assignor } = payload
    const method = verb === 'put' ? 'update' : 'save'

    Assignor[method](assignor).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

const saveUsingStore = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const { verb, dataAssignor } = payload
    const method = verb === 'put' ? 'update' : 'save'
    payload.dataAssignor.min_value = payload.dataAssignor.min_value === 0 ? '' : payload.dataAssignor.min_value

    Assignor[method](dataAssignor).then((response) => {
      resolve(response.data)
    })
    .catch((error) => {
      commit('SET_ERRORS', error.response.data)
      reject(error)
    })
  })
}

const saveByToken = (context, payload) => {
  return new Promise((resolve, reject) => {
    const { token, user } = payload

    Assignor.saveByToken(token, user).then((response) => {
      resolve(response.data)
    })
    .catch((error) => {
      reject(error)
    })
  })
}

const importAssignorList = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    Import.assignors(payload)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        let response = error.response.data
        let parsedErrors = [
          response.global_error,
          response.list_errors.map(
            (error) =>
              `Not imported line ${error.line} - Assignor '${error.assignor}': ${error.message}`
          )
        ]
        commit('SET_ERRORS', { import_assignors: parsedErrors })
        reject(error)
      })
  })
}

const exportAssignors = async () => {
  return new Promise((resolve, reject) => {
    Export.assignors()
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const resendWelcomeMailer = (context, id) => {
  return new Promise((resolve, reject) => {
    Mailer.resendWelcomeEmail(id)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const find = async (context, id) => {
  return new Promise((resolve, reject) => {
    Assignor.get(id)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const findCommit = async ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    Assignor.get(id)
      .then((response) => {
        commit('SET_ASSIGNOR', response.data)
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const sendDocs = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    Document.sendAssignorDocs(payload)
      .then((response) => {
        commit('SET_ASSIGNOR', response.data)
        commit('RESET_ERRORS_DOCS')
        resolve(response.data)
      })
      .catch((error) => {
        commit('SET_ERRORS', error.response.data)
        reject(error)
      })
  })
}

const changeStatus = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    Document.changeStatus(payload)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        commit('SET_ERRORS', error.response.data)
        reject(error)
      })
  })
}

const updateDocumentation = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    Document.update(payload).then((response) => {
      resolve(response.data)
      commit('RESET_ERRORS_DOCS')
    })
    .catch((error) => {
      commit('SET_ERRORS', error.response.data)
      reject(error)
    })
  })
}

const getDocumentByAssignor = ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    Assignor.documents(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fetchAssignorsByPayer = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Assignor.byPayers().then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fetchUsersByAssignor = async ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    Assignor.users(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const approveProtestos = async (context, id) => {
  return new Promise((resolve, reject) => {
    Serasa.approveProtestos(id)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const rejectProtestos = async (context, id) => {
  return new Promise((resolve, reject) => {
    Serasa.rejectProtestos(id)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const resetStateAssignor = ({ commit }) => {
  commit('RESET_ASSIGNOR')
}

const resetStateErrors = ({ commit }) => {
  commit('RESET_ERRORS')
}

const updateValues = ({ commit }, obj) => {
  commit('UPDATE_VALUES', obj)
}

const resetStateErrorsDocs = ({ commit }) => {
  commit('RESET_ERRORS_DOCS')
}

export default {
  fetch,
  fetchEligible,
  find,
  fetchCurrentAssignor,
  findByToken,
  findSerasa,
  findAssignorsWithProtestos,
  fetchAssignorsWithInvoiceImported,
  findInvoiceByAssignor,
  save,
  saveByToken,
  importAssignorList,
  exportAssignors,
  resendWelcomeMailer,
  resetStateAssignor,
  resetStateErrors,
  updateValues,
  saveUsingStore,
  findCommit,
  sendDocs,
  changeStatus,
  sendDocumentations,
  fetchTemplateContractOptions,
  updateDocumentation,
  resetStateErrorsDocs,
  fetchAssignorsByPayer,
  fetchUsersByAssignor,
  getDocumentByAssignor,
  approveProtestos,
  rejectProtestos
}



// WEBPACK FOOTER //
// ./src/features/assignors/store/actions.js